import update from 'immutability-helper'
import React, { Fragment } from 'react'
import { CatalogBuilderConfig } from '../catalog/CatalogBuilder'
import { HtmlBuilderConfig } from '../HtmlBuilder'
import { SolutionBuilderConfig } from '../SolutionBuilder'
import { QuizBuilderConfig } from '../QuizBuilder'
import { rehostAssetUrl } from '../../../dux/modules/utils'

export const builderPreviewText = {
  news: {
    title: 'News',
    description:
      `A News asset allows users to read press releases and important or timely ` +
      `announcements. A News asset may be viewed on mobile or web.`,
  },
  feature: {
    title: 'Feature',
    description:
      `A Feature asset combines a single image asset with a description and related ` +
      `assets. Generally used within product and navigation assets, features provide detailed ` +
      `information. A Feature asset may be viewed on mobile or web.`,
  },
  product: {
    title: 'Product',
    description:
      `A Product asset combines a series of image assets with Features to produce a ` +
      `comprehensive and informative product walkaround. Products may be viewed on web and ` +
      `mobile.`,
  },
  navigator: {
    title: 'Navigator',
    description:
      `A Navigator provides an interactive visual experience to explore products, ` +
      `features, and other assets. Navigators may be viewed on web and mobile.`,
  },
  navigation: {
    title: 'Navigator',
    description:
      `A Navigator provides an interactive visual experience to explore products, ` +
      `features, and other assets. Navigators may be viewed on web and mobile.`,
  },
  comparison: {
    title: 'Comparison',
    description:
      `A Comparison asset allows users to compare specifications of multiple products. ` +
      `Comparisons may be viewed on mobile.`,
  },
  calculators: {
    title: 'Calculator',
    description:
      'A Calculator asset is an interative tool to help users find information ' +
      'quickly or demonstrate value / savings to a customer.\n\nFor now, only Pop Art can create new calculators.',
  },

  [CatalogBuilderConfig.key]: CatalogBuilderConfig.previewLabels,
  [HtmlBuilderConfig.key]: HtmlBuilderConfig.previewLabels,
  [SolutionBuilderConfig.key]: SolutionBuilderConfig.previewLabels,
  [QuizBuilderConfig.key]: QuizBuilderConfig.previewLabels,
}

export const builderHeaderData = {
  news: {
    linkTo: '/builders/home',
    crumbText: 'News',
    crumbIcon: 'fa fa-newspaper-o',
  },
  feature: {
    linkTo: '/builders/home',
    crumbText: 'Feature',
    crumbIcon: 'fa fa-bullseye',
  },
  product: {
    linkTo: '/builders/home',
    crumbText: 'Product',
    crumbIcon: 'fa fa-cubes',
  },
  navigator: {
    linkTo: '/builders/home',
    crumbText: 'Navigator',
    crumbIcon: 'fa fa-sitemap',
  },
  comparison: {
    linkTo: '/builders/home',
    crumbText: 'Comparison',
    crumbIcon: 'fa fa-columns',
  },
  catalog: {
    linkTo: '/builders/home',
    crumbText: 'Catalog',
    crumbIcon: 'fa fa-file-o',
  },
  [CatalogBuilderConfig.key]: CatalogBuilderConfig.crumbTrail,
  [HtmlBuilderConfig.key]: HtmlBuilderConfig.crumbTrail,
  [SolutionBuilderConfig.key]: SolutionBuilderConfig.crumbTrail,
  [QuizBuilderConfig.key]: QuizBuilderConfig.crumbTrail,
}

export const iconForBuilder = (builderType) => {
  switch (builderType) {
    case 'feature':
      return 'fa-bullseye'
    case 'news':
      return 'fa-newspaper-o'
    case 'product':
      return 'fa-cubes'
    case 'navigator':
      return 'fa-sitemap'
    case 'comparison':
      return 'fa-columns'
    case CatalogBuilderConfig.key:
      return CatalogBuilderConfig.icon
    case HtmlBuilderConfig.key:
      return HtmlBuilderConfig.icon
    case SolutionBuilderConfig.key:
      return SolutionBuilderConfig.icon
    case 'html':
      return 'code'
    case 'quiz':
      return 'fa-check-square-o'
    default:
      return 'fa-file-o'
  }
}

export const callbackForBuilderSection = (_this, builderSection) => {
  switch (builderSection) {
    case 'leadImage':
      return _this.addLeadImage
    case 'pdfContent':
      return _this.addPdfContent
    case 'relatedAsset':
      return _this.addRelatedAsset
    case 'editRelatedAsset':
      return _this.editRelatedAssetCallback
    case 'addSlideAsset':
      return _this.addSlideCallback
    case 'replaceSlideAsset':
      return _this.replaceSlideCallback
    case 'addHotspot':
      return _this.addHotspotCallback
    case 'editHotspot':
      return _this.editHotspotCallback
    case 'addZone':
    case 'editZone':
      return _this.addZoneCallback
    case 'addAssetTarget':
      return _this.addAssetTarget
    case 'addFolderTarget':
      return _this.addFolderTarget
    case 'setComparisonImage':
      return _this.setComparisonImage
    default:
      return _this.handleFormValuesChange
  }
}

export const modalTitleForBuilderSection = (builderSection) => {
  switch (builderSection) {
    case 'leadImage':
      return 'Lead Image'
    case 'pdfContent':
      return 'News PDF'
    case 'relatedAsset':
      return 'Related Asset'
    case 'editRelatedAsset':
      return 'Related Asset'
    case 'addSlideAsset':
      return 'Add Slide Asset'
    case 'replaceSlideAsset':
      return 'Replace Slide Asset'
    case 'addHotspot':
      return 'Add Hotspot'
    case 'editHotspot':
      return 'Edit Hotspot'
    case 'addZone':
      return 'Add Nav Zone'
    case 'addAssetTarget':
      return 'Select Asset Target'
    case 'addFolderTarget':
      return 'Select Folder Target'
    case 'editZone':
      return 'Edit Nav Zone'
    case 'setComparisonImage':
      return 'Select Comparison Item Image'
    default:
      return 'Default Select'
  }
}

export const getNavzoneParentSlide = (navzoneId, slides) => {
  let parentId = null
  slides.forEach((slide) => {
    slide.navzones.forEach((zone) => {
      if (zone.id === navzoneId) parentId = slide.id
    })
  })
  return parentId
}

export const getZonesForTarget = (targetId, slides) => {
  let targets = []
  slides.forEach((slide) => {
    slide.navzones.forEach((zone) => {
      if (zone.targetId === targetId) targets.push(zone.id)
    })
  })
  return targets
}

export const prepComparisonDataForTable = (
  columns,
  dataSource,
  allAssets,
  action,
  deleteAction,
  isComparisonRowEditing,
) => {
  columns.forEach((column) => {
    if (column.key === 'attribute') {
      column.title = (
        <div className="comparison__table-col-hdr-txt">{column.title}</div>
      )
      column.width = 200
    } else if (column.key === 'category') {
      column.title = (
        <div className="comparison__table-col-hdr-txt">{column.title}</div>
      )
      column.width = 200
      column.onCell = (record) => ({
        record,
        dataIndex: column.dataIndex,
        editing: isComparisonRowEditing(record.attribute),
        disabled: record.category === 'meta',
      })
    } else if (
      column.image &&
      allAssets[column.image] &&
      allAssets[column.image].preview
    ) {
      column.onCell = (record) => ({
        record,
        dataIndex: column.dataIndex,
        editing: isComparisonRowEditing(record.attribute),
      })
      column.width = 200
      column.title = (
        <Fragment>
          <div className="comparison__items-group">
            <div className="comparison__item">
              <div
                style={{
                  boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.15)',
                  width: 165,
                  height: 123,
                  border: '1px solid #d8d8d8',
                  backgroundImage: `url(${rehostAssetUrl(
                    allAssets[column.image].preview,
                  )}_thumb-165x)`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                }}
              >
                <div className="comparison__item-action">
                  <div className="comparison__item-action-icon">
                    <i
                      className="fa fa-trash comparison__item-icon"
                      onClick={() => deleteAction(column.dataIndex)}
                    />
                    <i
                      className="fa fa-edit comparison__item-icon"
                      onClick={() =>
                        action('setComparisonImage', 'image', {
                          itemName: column.dataIndex,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="comparison__table-col-hdr-txt">{column.key}</div>
        </Fragment>
      )
    } else if (column.key !== 'attribute') {
      column.onCell = (record) => ({
        record,
        dataIndex: column.dataIndex,
        editing: isComparisonRowEditing(record.attribute),
      })
      column.width = 200
      column.title = (
        <Fragment>
          <div className="comparison__items-group">
            <div className="comparison__item-blank">
              <span className="comparison__item-blank-text">
                There is nothing here. Yet.
              </span>
              <div
                className="comparison__item-action-blank"
                onClick={() =>
                  action('setComparisonImage', 'image', {
                    itemName: column.dataIndex,
                  })
                }
              >
                <i className="fa fa-plus-circle" />
                &nbsp; Asset
              </div>
            </div>
          </div>
          <div className="comparison__table-col-hdr-txt">{column.key}</div>
        </Fragment>
      )
    }
  })
  // Sort by category, then attribute (meta category always first)
  dataSource.sort((a, b) => {
    if (a.category !== b.category) {
      if (a.category === 'meta') {
        return -1
      }
      if (b.category === 'meta') {
        return 1
      }
      return (a.category || '').localeCompare(b.category)
    }

    return a.attribute.localeCompare(b.attribute)
  })

  return {
    columns,
    dataSource,
  }
}

export const convertTableToTSV = (tableData) => {
  let TSVData = []
  let itemName = ['itemName', 'meta']
  let itemImage = ['itemImage', 'meta']
  tableData.columns.forEach((column) => {
    if (column.dataIndex !== 'attribute' && column.dataIndex !== 'category') {
      itemName.push(column.key)
      itemImage.push(column.image || null)
    }
  })
  TSVData.push(itemName.join('\t'), itemImage.join('\t'))
  tableData.dataSource.forEach((row) => {
    let dataRow = []
    dataRow.push(row.attribute, row.category || null)
    itemName.forEach((item, index) => {
      if (index > 1) {
        dataRow.push(row[item])
      }
    })
    TSVData.push(dataRow.join('\t'))
  })
  return TSVData.join('\r')
}

export const convertComparisonObjectToTable = (comparisonObject) => {
  let classifications = []
  let dataSource = []
  let dataSourceKey = 2 // For consistency with lambda parsing
  let columns = [
    {
      title: 'Attribute',
      dataIndex: 'attribute',
      key: 'attribute',
      editable: true,
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      editable: true,
    },
  ]
  const keys = Object.keys(comparisonObject).sort((a, b) => a.localeCompare(b))
  keys.forEach((item, index) => {
    columns.push({
      editable: true,
      title: item,
      dataIndex: item,
      key: item,
      image:
        comparisonObject[item].meta.itemImage ||
        comparisonObject[item].meta.image,
    })
    // Initialize dataSource
    if (index === 0) {
      dataSource.push({
        key: dataSourceKey,
        attribute: 'classification',
        category: 'meta',
      })
      Object.keys(comparisonObject[item]).forEach((category) => {
        if (category !== 'meta') {
          Object.keys(comparisonObject[item][category]).forEach((attribute) => {
            dataSourceKey = dataSourceKey + 1
            dataSource.push({
              key: dataSourceKey,
              attribute: attribute,
              category: category,
              editable: true,
            })
          })
        }
      })
    }
  })
  // add rows to data source
  dataSource.forEach((row) => {
    keys.forEach((item) => {
      if (
        row.attribute.toLowerCase() === 'classification' &&
        comparisonObject[item][row.category][row.attribute] !== '' &&
        classifications.indexOf(
          comparisonObject[item][row.category][row.attribute],
        ) < 0
      ) {
        classifications.push(
          comparisonObject[item][row.category][row.attribute],
        )
      }
      row[item] = comparisonObject[item][row.category][row.attribute]
    })
  })

  // Sort by category, then attribute (meta category always first)
  dataSource.sort((a, b) => {
    if (a.category !== b.category) {
      if (a.category === 'meta') {
        return -1
      }
      if (b.category === 'meta') {
        return 1
      }
      return (a.category || '').localeCompare(b.category)
    }

    return a.attribute.localeCompare(b.attribute)
  })
  return {
    columns,
    dataSource,
    classifications,
  }
}

export const applyUpdatesToComparisonObject = (
  original,
  newValues,
  oldValues,
) => {
  let newObject = { ...original }
  const items = Object.keys(original)
  items.forEach((item) => {
    if (
      oldValues.category !== newValues.category &&
      oldValues.category !== 'meta'
    ) {
      newObject = update(newObject, {
        [item]: {
          // Copy new category from original object (if it exists)
          [newValues.category]: {
            $set: Object.assign({}, original[item][newValues.category], {
              [newValues[oldValues.attribute]]: newValues[item],
            }),
          },
          // delete the previous attribute
          [oldValues.category]: {
            $unset: [oldValues.attribute],
          },
        },
      })
      //there are no attributes under the old category, delete it
      if (Object.keys(newObject[item][oldValues.category]).length === 0) {
        newObject = update(newObject, {
          [item]: {
            $unset: [oldValues.category],
          },
        })
      }
    }
    // If the attribute name changed, update the attribute (make sure category still exists)
    if (
      oldValues.category !== 'meta' &&
      original[item][newValues.category] &&
      !original[item][newValues.category][newValues[oldValues.attribute]]
    ) {
      newObject = update(newObject, {
        [item]: {
          [newValues.category]: {
            $unset: [oldValues.attribute],
          },
        },
      })
    }
    // Set the item value
    if (
      oldValues.category !== 'meta' ||
      (oldValues.category === 'meta' &&
        oldValues.attribute === newValues[oldValues.attribute])
    ) {
      newObject = update(newObject, {
        [item]: {
          [newValues.category]: {
            [newValues[oldValues.attribute]]: {
              $set: newValues[item],
            },
          },
        },
      })
    }
  })
  return newObject
}
